const arstimer = 'd1-arstimer';
const prosent = 'd2-prosent';

export default {
    d1_arstimer: arstimer,
    d2_prosent: prosent,
};
